/* eslint-disable react/no-array-index-key */
import React from 'react';
import Field from '../../../components/Field/Field';

const renderContent = (data) =>
  data.map((row, rowIndex) => (
    <div key={`o-grid__row-${rowIndex}`} className="o-grid__row">
      {row.map(({ col, label, value }, colIndex) => (
        <div key={`o-grid__col-${colIndex}`} className={`o-grid__col-${col}`}>
          <Field condensed label={label}>
            {value || '-'}
          </Field>
        </div>
      ))}
    </div>
  ));

export default renderContent;
